import { getAccountByGroupNum, getAccountRenewalPeriods } from '../../../actions/accounts.js';
import * as dates from "@simplybenefits/sb-dates";
import * as notifier from '../../../actions/notifier.js';

/**
 *
 * @param groupNum
 * @returns {function(*): Promise<*>}
 */
export const getRenewalPeriodsByGroupNum = (groupNum) => async (dispatch) => {
    const account = await dispatch(getAccountByGroupNum(groupNum));
    if (!account.accountID) {
        return {};
    }

    const statuses = [ 'In Renewal', 'Completed' ];
    const renewalPeriods = await dispatch(getAccountRenewalPeriods(account.accountID, statuses));

    if (renewalPeriods.length === 0) {
        dispatch(notifier.displayError({
            code: 'NOT_FOUND',
            verbiage: `Group ${ groupNum } has not reached the end of their first experience period. Please try again when the group is ready for renewal.`
        }));

        return {};
    }

    const renewalPeriodsEntries = renewalPeriods
        .map(({ periodStart, periodEnd, renewalID }) => [ `${ dates.formatDateForDisplay(periodStart) } - ${ dates.formatDateForDisplay(periodEnd) }`, renewalID ]);

    return Object.fromEntries(renewalPeriodsEntries);
};